<template>
    <div class="place-wraper"
         v-bind:class="{'table-mode':!tablePlace}"
    >
        <div class="table-place">
            <div id="table-container" class="container">
                <div class="row"
                     v-for="(line, key) in listTableCalc"
                >
                    <div class="col s5ths"
                         v-for="(item, i) in line"
                    >
                        <div class="base-image"
                             :id="'table-'+item.slug"
                             v-bind:style="{'min-height':item.height+'px', 'height':item.height+'px', 'width':item.width+'px', }"
                        >
                        </div>
                        <div class="envbutton"
                             v-on:click="selectEnvironment(item.id)"
                        >
                            {{item.title}}

                        </div>
                        <div class="text-wrap"
                        >
                            <div class="description"
                            >
                                {{item.description}}
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
        <div class="city-place"
             v-bind:class="{ show : animateStart}"
        >
            <div class="cloud-wraper">
                <img class="cloud-image cloud1" src="/assets/images/sys/cloud1.svg"
                     v-bind:class="{'animate':tablePlace, 'pause':!tablePlace }"
                     v-bind:style="{width:192*widthKoef+'px'}"
                />
                <img class="cloud-image cloud2" src="/assets/images/sys/cloud2.svg"
                     v-bind:class="{'animate':tablePlace}"
                     v-bind:style="{width:100*widthKoef+'px'}"
                />
                <img class="cloud-image cloud3" src="/assets/images/sys/cloud3.svg"
                     v-bind:class="{'animate':tablePlace}"
                     v-bind:style="{width:67*widthKoef+'px'}"
                />
                <img class="cloud-image cloud4" src="/assets/images/sys/cloud4.svg"
                     v-bind:class="{'animate':tablePlace}"
                     v-bind:style="{width:50*widthKoef+'px'}"
                />
            </div>
            <div class="bg-wraper">
                <img class="bg-image" id="bg-image" src="/assets/images/sys/bg.svg"
                     v-bind:class="{'animate':tablePlace}"
                />
                <img class="bg-template" id="bg-template" src="/assets/images/sys/bg.png"/>
            </div>
            <div class="city-section">

                <div class="bridge-wrap">

                    <img class="buildelement bridg-light" src="/assets/images/svg/bridg-light.svg"/>
                    <div class="trains">
                        <img class="buildelement train train1" src="/assets/images/svg/train.svg"
                             v-bind:style="{width:600*widthKoef+'px'}"
                        />
                        <img class="buildelement train train2" src="/assets/images/svg/train.svg"
                             v-bind:style="{width:600*widthKoef+'px'}"
                        />
                    </div>
                    <img class="buildelement bridge" src="/assets/images/svg/bridge.svg"/>
                </div>
                <div class="road">
                    <div class="env-section">
                        <img class="buildelement road-light" src="/assets/images/svg/road-light.svg"/>
                    </div>
                    <img class="buildelement road" src="/assets/images/svg/road.svg"/>

                    <img class="bike bike1" src="/assets/images/svg/bike1.svg"
                         v-bind:style="{width:83*widthKoef+'px'}"
                    />
                    <img class="bike bike2" src="/assets/images/svg/bike2.svg"
                         v-bind:style="{width:93*widthKoef+'px'}"
                    />
                    <img class="car car1" src="/assets/images/svg/car1.svg"
                         v-bind:style="{width:240*widthKoef+'px'}"
                    />
                    <img class="car car2" src="/assets/images/svg/car2.svg"
                         v-bind:style="{width:240*widthKoef+'px'}"
                    />
                </div>
            </div>
        </div>

        <div class="env-place">

            <div class="env-item"
                 v-for="(env, key) in envList"
                 :key="key"
                 v-bind:style="{
                     left:env.left+'px',
                     top:env.top+'px',
                     width:env.width +'px',
                     'z-index':(env.level+1)*100,

                 }"
                 v-bind:class="{active : env.active, 'item-front':env.subenv, level0:env.level==0}"
                 v-on:click="selectEnvironment(env.id)"
                 @mouseover="env.active = true"
                 @mouseleave="env.active = false"
            >

                <div class="env-img"
                     v-bind:style="{ width:env.width +'px'}"
                     v-if="env.icon"
                     :id="env.slug"
                >
                    <div class="sub-menu"
                         v-bind:class="{active : activeOficeMenu}"
                         v-if="env.slug == 'groupoffice' || env.slug == 'groupbank'"
                    >
                        <ul class="menu-index-top">
                            <li
                                v-for="(item, key) in env.subenv"
                                v-on:click="selectEnvironment(item.id)"
                            >
                                {{item.title}}
                            </li>
                        </ul>
                    </div>
                    <div class="envbutton"
                         v-on:click="selectEnvironment(env.id)"
                    >
                        {{env.title}}
                    </div>

                    <img class="img"
                         :src="env.icon"
                         v-bind:style="{width:(env.width) +'px'}"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CityTable",
        props: ['tablePlace', 'listEnvParam'],
        data() {
            return {
                envListImages: false,
                widthTableKoef: 1,
                widthKoef: 1,
                minImageHeight1: 100,
                minImageHeight2: 100,
                minTextHeight1: 100,
                minTextHeight2: 100,
                animateStart: false,
                activeOficeMenu: false,
                bacgroundProportion: 1920 / 1080,
                cityElements: [
                    {
                        width: 2440,
                        height: 658,//357+295,
                    },
                    {
                        width: 2440,
                        height: 295,
                    },

                ],
                bgImage: {
                    width: 10000,
                    height: 10000,
                },
                // listTop: [
                //     'groupoffice',
                //     'home-office',
                //     'manufacturing',
                //     'logistics-distribution',
                //     'transport-hub',
                //     'health',
                //     'data-center',
                //     'construction-site'
                // ],
                // listUnder: [
                //     'high-street',
                //     'groupbank',
                //     'department-store',
                //     'supermarket',
                //     'betshop',
                //     'phoneshop',
                //     'coffee-shop',
                // ],
                // envListTop: false,
                // envListUnder: false,

                listData: [
                    [
                        'groupoffice',
                        'home-office',
                        'manufacturing',
                        'logistics-distribution',
                        'transport-hub',
                        'health',
                        'data-center',
                        'construction-site'
                    ],
                    [
                        'high-street',
                        'groupbank',
                        'department-store',
                        'supermarket',
                        'betshop',
                        'phoneshop',
                        'coffee-shop',
                    ]
                ],
                listTable: [
                    [
                        'groupoffice',
                        'home-office',
                        'manufacturing',
                        'logistics-distribution',
                        'transport-hub'
                    ], [
                        'health',
                        'data-center',
                        'construction-site',
                        'high-street',
                        'groupbank'
                    ], [
                        'department-store',
                        'supermarket',
                        'betshop',
                        'phoneshop',
                        'coffee-shop',
                    ]
                ],
                listTableCalc: false,
                envList: false,
                loadComplete: false,
            }
        },
        watch: {
            'cityElements'() {

            },
            // 'loadComplete'() {
            //     this.locateEnvironments();
            // },
            'widthKoef'() {
                setTimeout(this.checkLoadComleted(), 100);
            },
            'tablePlace'() {
                this.checkLoadComleted()
                setTimeout(this.checkLoadComleted(), 100);
            },
            'envListTop'() {
            }

        },
        computed: {},
        mounted() {
            // document.onreadystatechange = () => {
            //     if (document.readyState == "complete") {
            //         this.loadComplete = true;
            //         this.locateEnvironments();
            //     }
            // }
            // window.addEventListener('load', () => {
            //     this.loadComplete = true;
            //     // this.setWidthKoef();
            //
            //     this.locateEnvironments();
            // });

            this.setWidthKoef();
            this.checkLoadComleted();
        },
        methods: {
            checkLoadComleted() {
                let bg = document.getElementById("bg-template");
                let imgBG = new Image();
                imgBG.onload = () => {
                    this.bgImage = {
                        width: imgBG.width,
                        height: imgBG.height
                    };

                    this.locateEnvironments();

                }
                imgBG.src = bg.src;

                // let section_collection = document.getElementsByClassName("buildelement");
                // section_collection.forEach((el, level) => {
                //     let imgX = new Image();
                //     imgX.onload = () => {
                //         this.cityElements[''+level] = {
                //             width: imgX.width,
                //             height: imgX.height
                //         };
                //         this.locateEnvironments();
                //     }
                //     imgX.src = el.src
                // })

                setTimeout(() => {
                    this.setlistTableCalc();
                    if (this.listTableCalc === false) {
                        this.checkLoadComleted();
                    } else {
                        this.locateEnvironments();
                    }
                }, 100);
            },
            areaClick() {
                this.locateEnvironments();
            },
            setlistTableCalc() {
                // if (this.loadComplete) {
                let tableData = [];
                let loadok = true;
                this.listTable.forEach((level_data, level) => {
                    let row = [];
                    let maxHeightRowEl = 0;
                    level_data.forEach((item_data, i) => {
                        let env = this.globalData.environments.find((el) => {
                            return el.slug == item_data;
                        });

                        //special for very hight envitonment
                        let internalCoef = 1;
                        if (item_data == 'construction-site') {
                            // internalCoef = 0.8
                        }
                        let qEnv = document.getElementById(item_data);
                        if (qEnv === null) {
                            loadok = false;
                        } else {
                            let h = qEnv.querySelector('.img').offsetHeight;
                            let w = qEnv.querySelector('.img').offsetWidth;
                            let new_h = Math.round(this.listEnvParam[item_data].width * h / w) * this.widthTableKoef * internalCoef
                            let row_el = {
                                id: env.id,
                                slug: item_data,
                                height: new_h,
                                width: this.listEnvParam[item_data].width * this.widthTableKoef,
                                title: env.title,
                                description: env.description,
                            }
                            if (maxHeightRowEl < new_h) {
                                maxHeightRowEl = new_h
                            }
                            row.push(row_el)
                        }
                    })
                    row.forEach((item) => {
                        item.height = maxHeightRowEl;
                    })
                    tableData.push(row)
                });
                if (loadok) {
                    this.listTableCalc = tableData;
                }
                // }
            },
            locateEnvironments() {
                this.setlistTableCalc();
                let navList = [];
                this.globalData.environments.forEach((env_element, i) => {
                    let elementTop = 0;
                    let elementLeft = 0;
                    let elementWidth = 0;
                    let elementLevel = 0;
                    if (!env_element.hasOwnProperty('parent')) {
                        if (this.tablePlace) {
                            let section_collection = document.getElementsByClassName("env-section");
                            this.listData.forEach((level_data, level) => {
                                if (level_data.indexOf(env_element.slug) != -1) {
                                    // elementTop = this.getOffset(section_collection[level]).top;
                                    if (this.cityElements[level]) {
                                        if (this.bacgroundProportion < this.getWinSize().x / this.getWinSize().y) {
                                            elementTop = this.getWinSize().x / this.bacgroundProportion - this.cityElements[level].height * this.widthKoef + 1;
                                        } else {
                                            elementTop = this.getWinSize().y - this.cityElements[level].height * this.widthKoef + 1;
                                        }
                                    } else {
                                        elementTop = 1000;
                                    }
                                    elementLevel = level
                                }
                            })

                            elementLeft = (this.listEnvParam[env_element.slug].left * this.getWinSize().x) / 100;
                            elementWidth = this.listEnvParam[env_element.slug].width * this.widthKoef;
                        } else {
                            //special for very hight envitonment
                            let internalCoef = 1;
                            if (env_element.slug == 'construction-site') {
                                // internalCoef = 0.8
                            }
                            let imagePosition = document.getElementById('table-' + env_element.slug)
                            elementTop = this.getOffset(imagePosition).top + imagePosition.offsetHeight;
                            elementLeft = this.getOffset(imagePosition).left;
                            elementWidth = this.listEnvParam[env_element.slug].width * this.widthTableKoef * internalCoef;

                        }
                        let item_element = {
                            active: false,
                            id: env_element.id,
                            level: elementLevel,
                            icon: env_element.icon,
                            slug: env_element.slug,
                            title: env_element.title,
                            left: elementLeft,
                            top: elementTop,
                            width: elementWidth,
                            description: env_element.description,
                        }
                        if (env_element.grouptype) {
                            item_element.subenv = this.globalData.environments.filter((el) => {
                                return el.parent == env_element.id;
                            });
                            navList.push(item_element)
                        } else if (!env_element.parent) {
                            navList.push(item_element)
                        }
                    }

                });

                this.envList = navList;
            },

            activateThisElem(slug, statsus) {
                if (slug == 'groupoffice') {
                    this.activeOficeMenu = statsus;
                }
            },
            selectEnvironment(id) {
                this.$emit('setActiveEnv', id);
            },
            setWidthKoef() {
                let area = document.getElementById("table-container");
                let tsbleArea = {
                    x: area.innerWidth || area.clientWidth,
                    y: area.innerHeight || area.clientHeight
                }
                this.widthTableKoef = tsbleArea.x / 2400;
                this.widthKoef = this.getWinSize().x / 2400;
                this.locateEnvironments()
            },
            getWinSize() {
                var body = document.documentElement || document.body;

                return {
                    x: window.innerWidth || body.clientWidth,
                    y: window.innerHeight || body.clientHeight
                }
            },
            getOffset(el) {
                var _x = 0;
                var _y = 0;
                while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
                    _x += el.offsetLeft - el.scrollLeft;
                    _y += el.offsetTop - el.scrollTop;
                    el = el.offsetParent;
                }
                return {top: _y, left: _x};
            },

        },
        updated() {
            // setTimeout(() => {
            //     this.setWidthKoef()
            // }, 100);
        },
        created() {
            window.addEventListener("resize", this.setWidthKoef);
        },
        destroyed() {
            window.removeEventListener("resize", this.setWidthKoef);
        },
    }
</script>

<style lang="scss" scoped>

</style>